import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const TeamSection = () => {

  const teamMembers = [
    { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1769946400/amir-iqbal-ceo_kehy1p.webp", name: "Amir Iqbal", role: "Director"},
    { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1774894330/blank-profile-picture-973460_1280_moatcl.webp", name: "Samar Iqbal", role: "Director"},
    // { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1774894330/blank-profile-picture-973460_1280_moatcl.webp", name: "Kinza Zafar", role: "Branch Manager" },
    { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1774894330/blank-profile-picture-973460_1280_moatcl.webp", name: "David Salins", role: "Operation Manager" },
    { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1769947249/reedhwan-ibrahim_s4cbtz.png", name: "Reedhwan Ibrahim", role: "Marketing Manager" },
    // { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1769947249/faizan-zeb_vjra3c.png", name: "Faizan Zeb", role: "Admissions Manager" },
    { img: "https://res.cloudinary.com/dxvic6bfo/image/upload/v1761043669/Mahnoor_gjpl5i.png", name: "Mahnoor Khan", role: "Marketing Officer" },
    { img: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1774894330/blank-profile-picture-973460_1280_moatcl.webp", name: "Aiman Habib", role: "Student Finance Coordinator" },
  ];

  return (
    <div className="container-fluid py-5 mb-5 team">
      <div className="container">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: "600px" }}>
          <h5 className="text-primary">Our Team</h5>
          <h1>Meet Our Expert Team</h1>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{ delay: 3000 }}
          navigation
          pagination={{ clickable: true }}

          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
          }}
        >
          {teamMembers.map((member, index) => (
            <SwiperSlide key={index}>
              <div className="p-2 h-100">
                <div className="team-item text-center h-100 d-flex flex-column justify-content-between">
                  
                  <div className="team-img mx-auto mt-4">
                    <img
                      src={member.img}
                      alt={member.name}
                      className="img-fluid rounded-circle w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>

                  <div className="team-name py-3">
                    <h4>{member.name}</h4>
                    <p className="text-muted">{member.role}</p>
                  </div>

                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </div>
  );
};

export default TeamSection;